import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {
  "title": "Next Steps"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/cesdk/ui/configuration/basics"
        }}>{`Perform Basic Configuration`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/cesdk/ui/guides/assets-served-from-your-own-servers"
        }}>{`Serve assets from your own servers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/cesdk/engine/quickstart/#licensing"
        }}>{`Create and use a license key`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/cesdk/ui/configuration/callbacks"
        }}>{`Configure Callbacks`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/cesdk/ui/guides/i18n/"
        }}>{`Add Localization`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/docs/cesdk/ui/guides/theming/"
        }}>{`Adapt the User Interface`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      